import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toast from './toast';

export const ToastContainer = ({ toastData: { messageData } }) => (
    messageData ?
        <div>
            <Toast messageData={messageData} />
        </div> : null
);

function mapStateToProps(state) {
    return {
        toastData: state.toastData
    };
}

ToastContainer.propTypes = {
    toastData: PropTypes.shape({
        messageData: PropTypes.object
    })
};

export default connect(mapStateToProps)(ToastContainer);



// WEBPACK FOOTER //
// ./components/toast/toast-container.js